import { Constants } from "../constants/constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from "../utils/utils";

@Injectable({
  providedIn: "root",
})
export class AutorizacionPedidosService {
  constructor(private http: HttpClient, private utils: Utils) {}

  public getAutorizacionPedido(idExEncabezado): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AUTORIZACION_PEDIDOS +
      "/" +
      idExEncabezado;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Autorización Pedidos",
            text: "Error Cargando Autorización Pedidos.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public getAutorizacionPedidos(
    idUsuario,
    agencia,
    fechaInicial,
    fechaFinal,
    idUsuarioConsulta,
    idDistribuidora
  ): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AUTORIZACION_PEDIDOS +
      "/" +
      idUsuario +
      "/" +
      agencia +
      "/" +
      fechaInicial +
      "/" +
      fechaFinal +
      "/" +
      idUsuarioConsulta +
      "/" +
      idDistribuidora;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError((err) => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Autorización Pedidos",
            text: "Error Cargando Autorización Pedidos.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public postAutorizacionPedido(params): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_AUTORIZACION_PEDIDOS;
    return this.http.post<any>(url, params).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Autorización Pedido",
            text: "Verifique la informacion ingresada.",
            icon: "error",
            confirmButtonColor: "#127570",
          });
        }

        return throwError(err);
      })
    );
  }

  public putAutorizacionPedido(idAutorizacion, idUsuario): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AUTORIZACION_PEDIDOS +
      "/" +
      idAutorizacion +
      "/" +
      idUsuario;
    return this.http.put<any>(url, null).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Autorización Pedido",
            text:
              "Error actualizando información de la autorización del pedido.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }

  public putAutorizacionPedidoEstado(idAutorizacion, param): Observable<any> {
    const url =
      Constants.BASE_URL +
      Constants.URL_AUTORIZACION_PEDIDOS +
      "/" +
      idAutorizacion;
    return this.http.put<any>(url, param).pipe(
      catchError((err) => {
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: "Error Autorización Pedido",
            text:
              "Error actualizando información de la autorización del pedido.",
            icon: "error",
          });
        }

        return throwError(err);
      })
    );
  }
}
